import React from 'react';

import useClassy from '@core/hooks/useClassy';

import styles from './LLMTextPreview.module.scss';

/**
 * A component that renders a preview of an LLM.txt file
 * Used in the AI settings panel to show how the LLM integration will look
 */
const LLMTextPreview: React.FC = () => {
  const bem = useClassy(styles, 'LLMTextPreview');

  return (
    <div className={bem('&')}>
      <div className={bem('-page')}>
        <div className={bem('-content')}>
          <div className={bem('-line', 'title')}>
            <span className={bem('-code')}>title: Product API Documentation</span>
          </div>
          <div className={bem('-line', 'section')}>
            <span className={bem('-code')}>## Guides</span>
          </div>
          <div className={bem('-line', 'indent')}>
            <span className={bem('-code')}>- [Getting Started](http://api.example.com/docs/getting-started.md)</span>
          </div>
          <div className={bem('-line', 'indent')}>
            <span className={bem('-code')}>- [Authentication](http://api.example.com/docs/authentication.md)</span>
          </div>
          <div className={bem('-line', 'section')}>
            <span className={bem('-code')}>## API Reference</span>
          </div>
          <div className={bem('-line', 'indent')}>
            <span className={bem('-code')}>- [List all products](http://api.example.com/reference/list-products)</span>
          </div>
          <div className={bem('-line', 'indent')}>
            <span className={bem('-code')}>- [Get product details](http://api.example.com/reference/get-product)</span>
          </div>
          <div className={bem('-line', 'indent')}>
            <span className={bem('-code')}>
              - [Create a new product](http://api.example.com/reference/create-product)
            </span>
          </div>
          <div className={bem('-line', 'indent')}>
            <span className={bem('-code')}>- [Update a product](http://api.example.com/reference/update-product)</span>
          </div>
          <div className={bem('-line', 'indent')}>
            <span className={bem('-code')}>- [Delete a product](http://api.example.com/reference/delete-product)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LLMTextPreview;
